// @ts-ignore
import styleCSS from "./chart-watermark.style.scss?inline"

export class ChartWatermarkComponent extends HTMLElement {
  private _watermarkDiv: HTMLDivElement;
  private _img: HTMLImageElement;
  private _observer: MutationObserver;

  constructor() {
    super();
    const shadowRoot = this.attachShadow({ mode: 'open' });
    
    // Add styles
    const style = document.createElement('style');
    style.textContent = styleCSS;
    shadowRoot.appendChild(style);

    // Create watermark elements
    this._watermarkDiv = document.createElement('div');
    this._watermarkDiv.id = 'watermark';

    this._img = document.createElement('img');
    this._watermarkDiv.appendChild(this._img);

    shadowRoot.appendChild(this._watermarkDiv);

    // Set up theme change listener
    document.addEventListener('theme-changed', this.updateWatermarkImage.bind(this));
    this.updateWatermarkImage();

    // Set up mutation observer
    this._observer = new MutationObserver(this.handleMutations.bind(this));
  }

  connectedCallback() {
    this._observer.observe(this, {
      childList: true,
      subtree: true
    });
  }

  disconnectedCallback() {
    this._observer.disconnect();
    document.removeEventListener('theme-changed', this.updateWatermarkImage.bind(this));
  }

  private updateWatermarkImage() {
    const isDarkTheme = document.querySelector('body')?.classList.contains('dark-theme');
    this._img.src = isDarkTheme ? 'https://cdn.prod.website-files.com/641b227fcd5cd9726f0781aa/642c240b573e489a4c673a65_Layer_1.svg' : 'https://cdn.prod.website-files.com/641b227fcd5cd9726f0781aa/64522458e65139808624c4cf_logo.svg';
  }

  private handleMutations(mutations: MutationRecord[]) {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && !this.contains(this._watermarkDiv)) {
        this.appendChild(this._watermarkDiv);
      }
    });
  }
}

customElements.define('tbw-chart-watermark', ChartWatermarkComponent); 